/**
 * An animation with an integer value output.
 *
 * Uses a reference object pattern ({ value: number }) to allow external code to
 * observe the animated value. This is the TypeScript equivalent of the C++ IntPtr pattern.
 *
 * TypeScript port of C++ IntAnimation from tabanim/public/animation/IntAnimation.h
 */

import { Animation } from './BaseAnimation';

/**
 * Reference object for integer values.
 * External code can observe changes by reading the value property.
 */
export interface IntRef {
  value: number;
}

export abstract class IntAnimation extends Animation {
  private valueRef: IntRef;

  constructor(outValue: IntRef) {
    super();
    this.valueRef = outValue;
  }

  public getValue(): IntRef {
    return this.valueRef;
  }

  public setValue(value: IntRef): void {
    this.valueRef = value;
  }

  public setValueFromInt(value: number): void {
    this.valueRef.value = value;
  }

  public setValueByCopyingFrom(value: IntRef): void {
    this.valueRef.value = value.value;
  }
}
